// import styles
import '../styles/tailwind.css';

// import external dependencies
import 'jquery';
import 'slick-carousel';
import 'daterangepicker';

// Import everything from autoload
import.meta.glob('./autoload/**/*.js', { eager: true });

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateHome from './routes/templateHome';
import templateNewsOverview from './routes/templateNewsOverview';
import templateHistory from './routes/templateHistory';
import templateProjectsOverview from './routes/templateProjectsOverview';
import templateFrameworkContractor from './routes/templateFrameworkContractor';
import templateFrameworkFinder from './routes/templateFrameworkFinder';
import templateFrameworksLanding from './routes/templateFrameworksLanding';
import templateResources from './routes/templateResources';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    templateHome,
    templateNewsOverview,
    templateHistory,
    templateProjectsOverview,
    templateFrameworkContractor,
    templateFrameworkFinder,
    templateFrameworksLanding,
    templateResources,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
